import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { HeaderContainer, TitleGroup, Logo, Title, IconGroup, IconLink, NotificationBadge } from "./Header.styles";
import { alarmService } from "services/alarmService";
import logo from "assets/noTextLogo.png";
import searchIcon from "assets/MainImage/search.png";
import alarmIcon from "assets/MainImage/alarm.png";

function Header() {
  const [unreadCount, setUnreadCount] = useState<number>(0);

  useEffect(() => {
    const fetchUnreadCount = async () => {
      try {
        const count = await alarmService.getUnreadCount();
        setUnreadCount(count);
      } catch (error) {
        console.error('Failed to fetch unread alarm count:', error);
      }
    };

    // Initial fetch
    fetchUnreadCount();

    // Poll every 30 seconds
    const intervalId = setInterval(fetchUnreadCount, 10000);

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <HeaderContainer>
      <Link to="/home" style={{ textDecoration: 'none' }}>
        <TitleGroup>
          <Logo src={logo} alt="지금 우리 학교는 로고" />
          <Title>지금 우리 학교는</Title>
        </TitleGroup>
      </Link>
      <IconGroup>
        <IconLink to="/search" target="_self">
          <img src={searchIcon} alt="검색" style={{ width: '20px', height: '20px' }} />
        </IconLink>
        <IconLink to="/alarm">
          <img src={alarmIcon} alt="알림" style={{ width: '24px', height: '24px' }} />
          {unreadCount > 0 && (
            <NotificationBadge>
              {unreadCount > 99 ? '99+' : unreadCount}
            </NotificationBadge>
          )}
        </IconLink>
      </IconGroup>
    </HeaderContainer>
  );
}

export default Header;
